//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,MultiSelect} from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import Reporting from './../../../services/reporting.service';
import CONSTANT from './../../../../shared/constants/constant';
import moment from 'moment';
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'

export default {
  name: 'approvallogs',
  components: {
    //VueElementLoading,
    Pagination,
    BasicSelect,
    Loader,
    CustomExpandableTable,
    Multiselect

  },
  data: function() {
    return {
      approvalType : 'client',
      CompanyShortNameArr: [],
      selectedcompanyName:{
        text: '',
        value: ''
      },
      companyName:'',
      clientId:'',
      isLoading:false,
      showCompanyShortName:false,
      currentPage: 1,
      totalPage: 0,
      totalrows:0,
      totalCount:0,
      pageCount: 0,
      offset: 0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Company Short/Display Name','Object ID','Objects Type' ,'Request Date', 'Request By','Action'],
      innerTableColumn: [''],
      tableItems: [],
      getLogsList : [],
      viewFlag : false
    }
  },
  computed: {

  },
  mounted() {
    this.getCompanyShortName();
    this.getLogdata();
  },
  methods: {
    clearForm() {
      this.currentPage =  1;
      this.pageCount = 0;
      this.totalPage = 0;
      this.totalCount = 0;
      this.offset = 0;
      this.pageLimit = 10;
      this.clientId = '';
      this.companyName = '';
      this.approvalType = 'client';
      this.totalrows = 0;
      this.tableItems = [];
      this.selectedcompanyName = {
        text: '',
        value: ''
      },
      this.getLogdata();
      //document.getElementById("clientId").value= '';
      this.$validator.reset();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    removeClientComanyName(){
      this.companyName = '';
      this.selectedcompanyName = {
        text: '',
        value: ''
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getLogdata();
    },
    selectCompanyName(data){
        this.selectedcompanyName = data;
        this.companyName = data.value;
        this.clientId = '';
    },

    async getCompanyShortName(){
          try {
            this.isLoading = true;
            var CompanyShortList = []
            let result = await Reporting.getActiveInactiveClientList()
             CompanyShortList = result.data.data;
            for (var i = 0; i < CompanyShortList.length; i++) {
              this.CompanyShortNameArr.push({
                'value': CompanyShortList[i].ClientBusinessAccountId,
                'text': CompanyShortList[i].ClientShortName
              })
            }
            this.isLoading = false
          } catch(err){
            this.$alert(err.message,"Approval Logs","error");
          }
        },
        format_date(value){
         if (value) {
            return Util.displayDateTimeFormat(value)
          }
        },
        async getLogdata(){
          try {
            let payload = {
              "offset": this.offset,
              "limit": 10,
              "objectType" : this.approvalType
            }
            if (this.clientId) {
              payload.clientID = parseInt(this.clientId);
            }
            if (this.companyName) {
              payload.clientID = parseInt(this.companyName.value);
            }
            this.isLoading = true;
            let result = await Reporting.getapprovalLog(payload);
            this.isLoading = false;

            if (result.data.code == 200) {
              let reportLogsData = result.data.data.rows;
              //this.tableArr = result.data.data.rows;
              this.tableItems = [];
              for (var i = 0; i < reportLogsData.length; i++) {
                this.tableItems.push({
                  'Company Short/Display Name': (reportLogsData[i].clientname != undefined) ? reportLogsData[i].clientname : reportLogsData[i].objectname,
                  'Object ID': (reportLogsData[i].clientid != undefined) ? reportLogsData[i].clientid : reportLogsData[i].objectid,
                  'Objects Type' : reportLogsData[i].objecttype,
                  'Request Date' : Util.displayDateTimeFormat(reportLogsData[i].moduledate),
                  'Request By': reportLogsData[i].moduleactionby,
                  'id' : (reportLogsData[i].clientid != undefined) ? reportLogsData[i].clientid : reportLogsData[i].objectid
                })
              }
              this.totalrows = result.data.data.count
              if (this.totalrows < 10) {
                this.pageCount = 1
              } else {
                this.pageCount = Math.ceil(this.totalrows / 10);
              }
            }else {
              this.isLoading = false;
              this.$alert("Internal Server Error","Approval Logs","error");
            }
          } catch (e) {
            this.isLoading = false;
            this.$alert(e.message,"Approval Logs","error");
          }
        },
      onSubmitSearch(){
        this.offset = 0;
        this.currentPage = 1;
        if (this.approvalType != '' || this.companyName !== '' ||
        this.clientId  != '') {
          this.getLogdata();
        }else {
          return true;
        }
      },
      async getCustomTableEvent(event) {
        if (event.actionType == "view") {
          let payload = {
            objectType : this.approvalType
          }
          if (this.approvalType == 'client') {
            payload.clientID = event.id
          }else {
            payload.objectID = event.id
          }
          this.viewFlag = true;
          let result = await Reporting.getApprovalLogAgainObjectID(payload);
          this.getLogsList = result.data.data;
          this.viewFlag = false
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/modules/reporting/views/ApprovalLogs/approvalLogs/approvalLogs.component.js